import { Injectable } from '@angular/core';
import { OidcConfiguration } from '../../model/OidcConfiguration';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  /**
   * @return une clÃ© unique pour stocker un objet dans un Storage
   */
  getStorageKey(aPartialKey: string): string {
    return (
      OidcConfiguration.storagePrefix +
      "." +
      OidcConfiguration.client_id +
      aPartialKey
    ); //
  }
}
